<template>
  <div>
    <div>
      <section class="Haut">
        <header class="Fiche__header text-moyen">
          <div class="tl block text-bold">{{ date }} - références</div>
          <div class="tc block text-bold">&nbsp;</div>
          <div class="tr block text-bold">scalene architectes</div>
        </header>
      </section>
      <section
        class="Fiche__title ProjectTextIndex__title text-ttgros"
        style="display: flex;"
        v-if="title || titlesecond"
      >
        <span
          style="margin-top: -9px;
    margin-bottom: -12px;
    display: block;
    margin-right: 36mm;
    width: calc(21cm - 36mm);"
          :style="{ marginBottom: titlesecond ? '-12px' : '-7px' }"
          >{{ title }}</span
        ><span
          style="
        font-style: italic;
    margin-bottom: -14px;
    margin-left:auto;
    display: block;
    width: calc(21cm - 36mm);"
          >{{ titlesecond }}</span
        >
      </section>
      <div class="Fiche__header__notitle__spacer" v-else></div>
    </div>
    <table class="ProjectTextIndex">
      <thead>
        <tr>
          <th style="width: 51mm"><p>Projet</p></th>
          <th style="width: 51mm"><p>Programme</p></th>
          <th style="width: 36mm"><p>Lieu</p></th>
          <th style="width: 36mm"><p>Date</p></th>
          <th style="width: 36mm"></th>
          <th style="width: 51mm"><p>Maîtrise d'ouvrage</p></th>
          <th style="width: 51mm"><p>Maîtrise d'œuvre</p></th>
          <th style="width: 33mm"><p>Procédure</p></th>
          <th style="width: 19.5mm"><p>Surface</p></th>
          <th style="width: 19.5mm"><p>Budget</p></th>
          <svg width="100%" height="1px">
            <path
              style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
              d="M 0,0 H 5000"
            />
          </svg>
        </tr>
      </thead>
      <tbody>
        <slot> </slot>
      </tbody>
    </table>
    <span
      class="pageNumber ProjectTextIndex__pageNumber text-moyen"
      v-if="total > 1"
      >{{ index }}/{{ total }}</span
    >
  </div>
</template>
<script>
export default {
  name: "FichePortraitIndexTextuelCommonLarge",
  props: {
    date: {},
    total: {},
    index: {},
    title: {},
    titlesecond: {}
  }
};
</script>
